export class LiveRegion {
    private liveRegion: HTMLElement;

    constructor() {
        this.liveRegion = document.createElement('div');
        this.liveRegion.setAttribute('aria-live', 'polite');
        this.liveRegion.setAttribute('aria-atomic', 'true');
        this.liveRegion.classList.add('visually-hidden');
    }

    appendTo(container: HTMLElement) {
        container.appendChild(this.liveRegion);
    }

    announce(text: string) {
        this.liveRegion.textContent = text;
    }

    destroy() {
        this.liveRegion.parentElement.removeChild(this.liveRegion);
    }
}
